/* ==========================================================================
   SearcherFerryHotel > Client > Accommodation
   ========================================================================== */

/* Modules */
const { html } = require('common-tags');

const { addData } = require('@bluekiri/alexandria/helpers/dataHelpers');

const PanelAccommodationTemplate = require('../../../../panel-accommodation/template');
const PanelRoomsActions = require('../../../../panel-accommodation/client/js/store/actions'); // eslint-disable-line
const PanelAccommodationClient = require('../../../../panel-accommodation/client/js');

const { types } = require('../store/actions');
const InputPanelClient = require('../../../../input-panel/client/js');
const InputPanelActions = require('../../../../input-panel/client/js/store/actions');

const { renderBonus, renderDiscounts, initBonus, initDiscounts, destroyDiscounts } = require('./discounts');
const { renderAddRoom, initAddRoom, destroyAddRoom } = require('./addRoom');
const { destroyPanel } = require('../../../../input-panel/client/js/panel');

const { ACCOMMODATION } = require('../../../constants');
const configuration = require('../config');
const { validateAccommodation } = require('../validations');

function hasDiscounts(instance) {
    const { route = {} } = instance.store.select('data');
    const { discounts = [] } = route;

    return !(!discounts.length || (discounts.length === 1 && !discounts[0].type));
}

function hasResidents(instance) {
    const { route = {} } = instance.store.select('data');
    const { residents = [] } = route;

    return !(!residents.length || (residents.length === 1 && !residents[0].type));
}

function buildInfo(instance) {
    const { config = {}, store = {} } = instance;
    const { literals = {} } = config;
    const {
        adultAmountInfo = '',
        adultsAmountInfo = '',
        childAmountInfo = '',
        childrenAmountInfo = '',
        roomInfo = '',
        roomsInfo = ''
    } = literals;

    const { accommodation = {} } = store.select('data');
    const { rooms = [], totalRooms } = accommodation;
    const adults = rooms.map(room => room.people[0].value).reduce((acc, val) => acc + val);
    const children = rooms
        .map(room => {
            if (room.people[1]) return room.people[1].value;

            return 0;
        })
        .reduce((acc, val) => acc + val);

    /* Adults info literal */
    const adultsInfo =
        adults === 1 ? adultAmountInfo.replace('#number#', adults) : adultsAmountInfo.replace('#number#', adults);

    /* Children info literal */
    const childrenInfo =
        children === 1
            ? childAmountInfo.replace('#number#', children)
            : childrenAmountInfo.replace('#number#', children);

    /* Rooms info literal */
    const roomInfoLabel =
        totalRooms === 1 ? roomInfo.replace('#adults#', adultsInfo) : roomsInfo.replace('#adults#', adultsInfo);

    return children > 0
        ? roomInfoLabel.replace('#children#', childrenInfo).replace('#number#', totalRooms)
        : roomInfoLabel
              .replace('#children#', ' ')
              .replace('#number#', totalRooms)
              .replace(/\s{2,}/g, ' ')
              .trim();
}

function getPanelData(instance) {
    const { config = {} } = instance;
    const { accommodation = {}, literals = {} } = config;
    const {
        adultLabel = '',
        adultsLabel = '',
        adultsDescription = '',
        childLabel = '',
        childrenLabel = '',
        childrenDescription = ''
    } = literals;

    const { adults = ACCOMMODATION.adults, children = ACCOMMODATION.children, rooms } = accommodation;

    const { maxAge, defaultAge } = children;

    const rangeAge = [...Array(maxAge + 1).keys()].map((value, ind) => ({
        value,
        label: `${value}`,
        selected: ind === defaultAge
    }));

    const adultsData = {
        ...adults,
        personLabel: adultLabel,
        personsLabel: adultsLabel,
        personDescription: adultsDescription
    };

    const childrenData = {
        ...children,
        personLabel: childLabel,
        personsLabel: childrenLabel,
        personDescription: childrenDescription,
        agePersonLabel: 'Edad niño #number#',
        options: rangeAge
    };

    return {
        people: [adultsData, childrenData],
        rooms: rooms.map(room => ({
            people: [{ value: room.adults }, { value: room.children, ages: room.childrenAges }]
        }))
    };
}

function loadInfoAccommodation(instance) {
    if (!instance.accommodationInput) return;

    const inst = instance;

    const accommodationInfo = buildInfo(inst);

    inst.accommodationInput.actions.changeValue(accommodationInfo);
    inst.accommodationInput.input.hooks.input.title = accommodationInfo;
}

function renderRooms(instance) {
    const { config = {}, store = {} } = instance;
    const { context = {}, literals = {}, accommodation: accommodationConfig } = config;
    const { maxRooms = ACCOMMODATION.maxRooms, maxPeople = ACCOMMODATION.maxPeople } = accommodationConfig;

    /* Data store */
    const { accommodation } = store.select('data');
    const { rooms = [] } = accommodation;

    /* Build data panel-accommodation */
    const dataRooms = addData(
        {
            config: {
                literals,
                maxRooms,
                maxPeople
            },
            ...getPanelData(instance),
            rooms
        },
        { type: configuration().type.accommodation }
    );

    return PanelAccommodationTemplate(dataRooms, context);
}

function createPanelAccommodation(instance) {
    const { config = {} } = instance;
    const { literals = {} } = config;
    const { discountsTitle = '' } = literals;

    /* Templates / framents */
    const discountsTemplate = hasDiscounts(instance) ? renderDiscounts(instance) : '';
    const residentsTemplate = hasResidents(instance) ? renderBonus(instance) : '';
    const discountsFragment = `<div class='input-panel__title'>${discountsTitle}</div>
    <div class='input-panel__discounts'>${discountsTemplate} ${residentsTemplate}</div>`;
    const renderDiscountsFragment = hasDiscounts(instance) || hasResidents(instance) ? discountsFragment : '';

    return html(`
        <div class='input-panel__header'>${renderAddRoom(instance)}</div> 
        <div class='input-panel__body' ${configuration().hooks.panelBody}>${renderRooms(instance)}</div>
        <div class='input-panel__footer'>
            <div data-input-panel-footer></div>
            ${renderDiscountsFragment}
        </div>
    `);
}

function initRooms(instance) {
    const inst = instance;
    const { accommodationInput } = instance;

    /* Data Panel */
    const { panelType } = accommodationInput.store.select('data');
    const panelSelector = `[data-type="${panelType}"]`;

    inst.accommodation = PanelAccommodationClient(
        `${panelSelector} [data-component="PanelAccommodation"][data-type="${configuration().type.accommodation}"]`,
        { messageHook: accommodationInput.hooks.panelContent.querySelector('[data-input-panel-footer]') }
    );

    if (!inst.accommodation) return;

    /* Extend reactions */
    inst.reactions = {
        ...inst.reactions,
        updateDataRooms: inst.accommodation.store.subscribe((state, action) => {
            if (action.type !== PanelRoomsActions.types.UPDATE_ROOMS) return;

            /* Data accommodation-panel */
            const { rooms = [], totalPeople, totalRooms } = inst.accommodation.store.select('data');

            instance.actions.changeData({
                accommodation: { rooms, totalRooms, totalPeople }
            });
        }),

        setErrorRooms: inst.accommodation.store.subscribe((state, action) => {
            if (action.type !== PanelRoomsActions.types.SET_ERROR) return;

            if (inst.addRooms) inst.addRooms.actions.disable();

            validateAccommodation(inst);
        }),
        setValidRooms: inst.accommodation.store.subscribe((state, action) => {
            if (action.type !== PanelRoomsActions.types.SET_VALID) return;

            if (inst.addRooms) inst.addRooms.actions.enable();
            validateAccommodation(inst);
        })
    };
}

function addPanelAccommodation(instance) {
    const inst = instance;
    const { accommodationInput } = instance;

    /* add accomodation to panel */
    instance.accommodationInput.actions.setContent(createPanelAccommodation(instance));

    inst.hooks = {
        ...inst.hooks,
        panelBody: accommodationInput.panel.element.querySelector(`[${configuration().hooks.panelBody}]`)
    };

    /* Init components */
    initRooms(inst);
    initDiscounts(inst);
    initBonus(inst);
    initAddRoom(inst);
}

function initAccommodation(instance) {
    const inst = instance;
    const { config = {}, selector } = instance;

    inst.accommodationInput = InputPanelClient(
        `${selector} [data-component="InputPanel"][data-type="${configuration().type.accommodation}"]`
    );

    if (!inst.accommodationInput) return;

    /* Sync Store */
    if (config.accommodation) {
        const { rooms = [] } = getPanelData(instance);

        instance.actions.setData({ accommodation: { rooms, totalRooms: rooms.length } });
    }

    /* Sync data accommodation width input */
    loadInfoAccommodation(inst);

    /* Extends Reactions */
    inst.reactions = {
        ...inst.reactions,
        changeAccommodation: instance.store.subscribe((state, action) => {
            if (action.type !== types.CHANGE_DATA) return;
            if (!action.payload.accommodation) return;

            /* Sync data accommodation width input */
            loadInfoAccommodation(inst);
        }),
        destroyInputAccommodation: inst.accommodationInput.store.subscribe((state, action) => {
            if (action.type !== InputPanelActions.types.DESTROY) return;

            destroyPanel(inst);
            delete inst.accommodationInput;
        }),
        openAccommodation: inst.accommodationInput.store.subscribe((state, action) => {
            if (action.type !== InputPanelActions.types.OPEN_PANEL) return;

            addPanelAccommodation(inst);
            inst.actions.openPanel('accommodationInput');
        }),
        closeAccommodation: inst.accommodationInput.store.subscribe((state, action) => {
            if (action.type !== InputPanelActions.types.CLOSE_PANEL) return;

            destroyPanelAccommodation(inst);
            inst.actions.closePanel('accommodationInput');
        })
    };
}

function destroyPanelAccommodation(instance) {
    const inst = instance;
    if (!instance.accommodation) return;

    const { accommodation } = instance;

    accommodation.actions.destroy();

    /* Destroy discounts and bonus */
    destroyDiscounts(instance);
    destroyAddRoom(instance);

    delete inst.accommodation;
}

module.exports = {
    initAccommodation,
    addPanelAccommodation
};
